import { AxiosPromise } from 'axios';
import { axios } from '../axios';
import { ISystemDto } from './types';

export const getSystems = (): AxiosPromise<ISystemDto[]> => {
  // return Promise.resolve({ data: [{
  //   createdAt: "2025-08-24T12:00:00Z",
  //   id: 1,
  //   name: "test",
  //   serialNumber: "1",
  //   siteId: 1,
  //   state: {
  //     healthy: true,
  //     paused: false,
  //     online: true,
  //     estop: false,
  //   },
  //   enabledTasks: {
  //     fulfillment: true,
  //     consolidation: true,
  //   },
  //   updatedAt: "2025-08-24T12:00:00Z",
  // }] }) as unknown as AxiosPromise<ISystemDto[]>;
  return axios.get('/systems');
};

export const getSystem = (systemId: number): AxiosPromise<ISystemDto> => {
  return axios.get(`/systems/${systemId}`);
};
